import { finish, form, error } from '../../../modules/customers/actions/top-up';
import { Map, fromJS } from 'immutable';
import getErrorMessage from '../../../components/BetSlip/errors.jsx';

import api from '../../../api';

let messageReceiverInitialized = false;

let $lastId;

function initializeMessageReceiver(dispatch) {
    window.addEventListener('message', (e) => {
        let message = e.data;

        try {
            message = JSON.parse(message);
        } catch (err) {
            return;
        }

        if (message.action !== 'transaction-final') {
            return;
        }

        if (message.type === 'success') {
            api.get('/customers/' + $lastId).then(
                (customer) => dispatch(finish($lastId, { customer })),
                ({ errors }) => dispatch(error($lastId, errors))
            );
        } else if (message.reason) {
            dispatch(error($lastId, {paymentMethod:
                getErrorMessage(fromJS({ field: 'paymentMethod', code: message.reason }))}));
        } else {
            dispatch(error($lastId, message.error));
        }
    });
}

export function request(dispatch, { id, amount, paymentMethod, cachetoken, securitycode }) {
    if (!messageReceiverInitialized) {
        messageReceiverInitialized = true;
        initializeMessageReceiver(dispatch);
    }

    $lastId = id;

    api.post('/customers/' + id + '/deposits', { amount, paymentMethod, cachetoken, securitycode, channel: 'backoffice' }).then(
        (data) => {
            // paymentForm was realexPaymentForm, renamed for backward compatibility
            if (data.paymentForm) {
                dispatch(form(id, data));
            } else if (data.secureTradingPaymentForm) {
                dispatch(form(id, data));
            } else if (data.safeChargePaymentPage) {
                dispatch(form(id, data));
            } else {
                api.get('/customers/' + id).then(
                    (customer) => dispatch(finish(id, { customer, transaction: data })),
                    () => dispatch(finish(id, { transaction: data }))
                );
            }
        },
        ({ errors }) => dispatch(error(id, errors))
    );
}
